
__webpack_public_path__ = window.__webpack_public_path__;

import 'core-js';
import 'regenerator-runtime'; // for async/await

import 'scripts/helpers/external-links.js';

import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';
import VueScript2 from 'scripts/lib/script2.js';
import VueLazyLoad from 'vue-lazyload';
import VueMq from 'vue-mq';
import VueScrollTo from 'vue-scrollto';
import { mapState } from 'vuex';

import components from './components';
import store from './store';
import { ucfirst, upcase, unhandleize } from './filters/string.js';
import { money, moneyWithoutDecimals } from './filters/money.js';

import imageConfig from 'scripts/config/images.js';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import Vuemoment from 'vue-moment';
import IOLazyLoad from 'scripts/helpers/vanilla-io-lazyload.js';
import RechargeDashboard from 'scripts/helpers/subscriptions.js';


document.addEventListener('DOMContentLoaded', IOLazyLoad.setupObservers);
document.addEventListener('DOMContentLoaded', RechargeDashboard.setup);

const cssVars = require('../styles/variables.scss');
const appProxy = window.bva && window.bva.template === null;
Vue.config.productionTip = false;
Vue.use(Vue2TouchEvents);
Vue.use(VueScript2);

Vue.use(VueLazyLoad, {
  preload: 1.3,
  loading: imageConfig.loading,
  attempt: 1,
});

Vue.use(VueMq, {
  breakpoints: {
    mobile: parseInt(cssVars.breakTablet, 10),
    tablet: parseInt(cssVars.breakDesktop, 10),
    desktop: parseInt(cssVars.breakHd, 10),
    hd: Infinity,
  },
});

Vue.use(VueScrollTo, {
  container: "body",
});
//let scrollUp = VueScrollTo.scrollTo(element, duration, options);

Vue.filter('ucfirst', ucfirst);
Vue.filter('upcase', upcase);
Vue.filter('unhandleize', unhandleize);
Vue.filter('money', money);
Vue.filter('moneyWithoutDecimals', moneyWithoutDecimals);
const dataURL = 'https://joshua-tree-coffee-company.myshopify.com/products/subscription-test.json';
const dataURL2 = 'https://joshua-tree-coffee-company.myshopify.com/products/subscription-pre-paid.json';
//const collectionURL = 'https://joshua-tree-coffee-company.myshopify.com/collections/subscriptions/products.json';
const collectionURL = 'https://joshua-tree-coffee-company.myshopify.com/collections/subscriptions-auto-renew/products.json';

let dateFirstShipment = new Date();
//dateFirstShipment.setHours( dateFirstShipment.getHours() + 24); 
//let dateFirstShipmentFormatted = moment(dateFirstShipment).format('MMMM Do YYYY')

console.log('=== VUE DEBUG START ===');
console.log('Starting Vue initialization...');

try {
  new Vue({
  delimiters: ['${', '}'],
  store,
  components,
  comments: true,
  data:{
    currentStep:2,
    completedStep:1,
    direction: 'nextStep',
    summary: false,
    gift: false,
    active: 'wait',
    coffeeType: '',
    coffeeTypeImg: '',
    coffeeParent: '',
    coffeeOptions: [],
    coffeeOptionsProductHandle: [],
    beanGrind: '',
    beanGrindImg: '',
    size: '',
    sizeImg: '',
    sizeNum: '',
    shippingPrice: '',
    quantity: '',
    frequency: '',
    frequencyImg: '',
    freq_gift_title: '',
    frequencyNum: '',
    duration: '',
    durationImg: '',
    durationNum: '',
    variantId: '',
    variantTitle:'',
    compareTitle:'',
    ship_date:'',
    finalID:'',
    giftName:'',
    giftEmail:'',
    cartNote:'',
    giftWrap: false,
    cartNoteSelected: false,
    giftWrapVariantId: '',
    cartNoteVariantId: '',
    show: true,
    productHandle: '',
    product: [], // initialize empty array
    variant: [], // initialize empty array
    variantData: [], // initialize empty array
    collection: [], // initialize empty array
    VariantSubscriptionMap: {},
    subscription_id: '',
    hasSellingPlan: false,
    sellingPlanId: '',
    date: '',
    dateFormat: '',
    disabledDates: {to: dateFirstShipment},
    moment: moment,
    contact: {
      name: '',
      email: '',
    },
    grindOrder: 'alpha',
    popProductHandle: 'the-first-roast',
    popProduct: [],
    showPopReviews: false,
    currentRoast: '',
    roastsOpen: false
  },

  computed: {
    ...mapState({
      checkout: state => state.cart.checkout,
    }),
    featuredProductSlidesToShow () {
      if (this.$mq === 'mobile') return 1.8;
      if (this.$mq === 'tablet') return 3;
      return 4;
    },
    numShipments: function() {
      //console.log(this.durationNum, this.frequencyNum)
      var num = this.durationNum / this.frequencyNum;
      return Math.floor(num);
    },
    formattedPrice: function() {
      if (!this.variant || !this.variant.price) return '0.00';
      return typeof this.variant.price === 'number' ? (this.variant.price / 100).toFixed(2) : this.variant.price;
    },
    formattedComparePrice: function() {
      if (!this.variant || !this.variant.compare_at_price) return null;
      return typeof this.variant.compare_at_price === 'number' ? (this.variant.compare_at_price / 100).toFixed(2) : this.variant.compare_at_price;
    },
    pricePerCoffee: function() {
      if (!this.variant || !this.variant.price) {
        console.warn('Variant or price not available for price calculation');
        return '0.00';
      }
      
      // Check if price is in cents (number) or dollars (string)
      var price = typeof this.variant.price === 'number' ? this.variant.price / 100 : parseFloat(this.variant.price);
      
      var shipping = this.numShipments * Number.parseFloat(this.shippingPrice);
      var remainingCost = price - shipping;
      var eachCoffee = (remainingCost / this.numShipments).toFixed(2);
      return eachCoffee;
    },
    productUrl: function() {
      return "https://jtcoffee.com/products/" + this.popProductHandle;
    }
  },

  created () {
    this.$store.dispatch('params/init');
    this.$store.dispatch('cart/init');
    this.$store.dispatch('products/init');

    if (appProxy) {
      document.body.appendChild(document.getElementById('MainContent'));
    }
    var currentPage = window.location.pathname.split("/").pop();
    //console.log(currentPage)
    var self = this // create a closure to access component in the callback below
    if (currentPage === 'send-a-gift') {
      this.gift = true;
    }
    /* if (currentPage !== 'send-a-gift') {
      $.getJSON(dataURL, function (data) {
        self.product = data;
        console.log('product', data)
      });

    }else {
      this.gift = true;
      $.getJSON(dataURL2, function (data) {
        self.product = data;
        console.log('product', data)
      });
      $.getJSON(collectionURL, function (data) {
        self.collection = data;
        console.log('collection', data)
      });
    } */
  },
  mounted() {
    // on mount, start listening for load events
    // on a section load, re-mount section to reflect admin changes
    this.getPopProduct();

    document.addEventListener('shopify:section:load', (event) => {
      const sectionContainer = document.getElementById(event.target.id);
      const NewComponent = Vue.extend({
        components,
        store,
        Datepicker,
        moment,
        template: event.target.innerHTML,
      });
      const component = new NewComponent().$mount();

      sectionContainer.innerHTML = '';
      sectionContainer.appendChild(component.$el);
    });

    if (appProxy){
      document.getElementById('MainContentWrapper').appendChild(document.getElementById('MainContent'));
    }

  },

  watch: {
    date: function (val) {
      var selectedDate = val.setHours(0,0,0,0);
      var compareDate = dateFirstShipment.setHours(0,0,0,0);
      console.log({selectedDate}, {compareDate});
      var theInput = document.querySelector('#gift-wrap');

      if (selectedDate > compareDate) {
        this.giftWrap = false;
        if (theInput) {
          theInput.setAttribute('disabled', '');
          theInput.closest('.input--checkbox').classList.add('disabled');
        }
        
      } else {

        if (theInput) {
          theInput.removeAttribute('disabled', '');
          theInput.closest('.input--checkbox').classList.remove('disabled');
        }

      }
    },
    grindOrder: function() {
      console.log('grindOrder called')
      let grindItems = Array.from(document.querySelectorAll('.grind-item'));
      if (this.grindOrder === 'low') {
        grindItems.forEach((el) => {
          el.parentElement.style.order = el.dataset.grind_size;
        })
      }
      if (this.grindOrder === 'popular') {
        grindItems.forEach((el) => {
          el.parentElement.style.order = el.dataset.grind_pop;
        })
      }
      if (this.grindOrder === 'high') {
        grindItems.forEach((el) => {
          el.parentElement.style.order = parseInt(el.dataset.grind_size) * -1;
        })
      }
      if (this.grindOrder === 'alpha') {
        grindItems.forEach((el) => {
          el.parentElement.style.order = '';
        })
      }
    },
  },
  methods: {
    changeRoast(handle) {
      this.currentRoast = handle;
      let roastSlides = document.querySelectorAll('.roast-slide');
      roastSlides.forEach(function(el) {
        el.classList.remove('roast_slide_active')
      });
      let slideStr = '.roast-slide.' + handle;
      console.log('slideStr', slideStr);
      let roastSlide = document.querySelector(slideStr);
      console.log('roastSlide', roastSlide);
      roastSlide.classList.add('roast_slide_active')
    },
    getPopProduct() {
      console.log('getPopProduct called')
      var create_URL = "https://joshua-tree-coffee-company.myshopify.com/products/"+ this.popProductHandle + ".json";
      var vm = this;
      $.getJSON(create_URL)
        
        //console.log('vm.product:::', vm.product);
        .done(function( data ) {
          vm.product = data;
          console.log( "JSON Done: " );
        })
        .fail(function( jqxhr, textStatus, error ) {
          var err = textStatus + ", " + error;
          console.log( "Request Failed: " + err );
      });
        
    },
    productModal(handle) {
      console.log('ProductModal called: ', handle);
      if (handle) {
        this.popProductHandle = handle;
        this.getPopProduct();
        this.$store.dispatch('products/init')
        this.$store.dispatch('products/addProduct', handle);
        var pm = document.querySelector('.product-modal');
        pm.style.opacity = '1';
        pm.style.display = 'flex'
      } 
    },
    closeProductModal() {
      var pm = document.querySelector('.product-modal');
      pm.style.display = 'none';
      this.showPopReviews = false;
    },
    togglePopReviews() {
      this.showPopReviews = !this.showPopReviews;
    },
    getProduct (){
      var create_handle = this.duration + "-" + this.freq_gift_title + "-" + this.coffeeType; // build some sort of consitent string with selected variables
      //console.log('create_handle ', create_handle);
      create_handle = create_handle.replace(/\s+/g, '-').toLowerCase();
      this.productHandle = create_handle;
      //console.log('create_handle ', create_handle);

      var create_URL = "https://joshua-tree-coffee-company.myshopify.com/products/"+ create_handle + ".js";
      console.log('Fetching URL (with selling plans):', create_URL);

      this.compareTitle = this.size + ' / ' + this.beanGrind;
      var compareIt = this.compareTitle;
      console.log('=== VARIANT MATCHING LOGIC ===');
      console.log('Built compareIt string:', compareIt);
      console.log('Size:', this.size);
      console.log('BeanGrind:', this.beanGrind);

      var vm = this;
      $.getJSON(create_URL, function (data) {
        // Set the product data directly
        vm.product = data;
        
        console.log('Successfully loaded product:', create_handle);
        
        // Check for selling plans on the product
        if (vm.product && vm.product.selling_plan_groups && vm.product.selling_plan_groups.length > 0) {
          vm.hasSellingPlan = true;
          // Get the first selling plan from the first group (you may want to match based on frequency later)
          vm.sellingPlanId = vm.product.selling_plan_groups[0].selling_plans[0].id;
          console.log('Product has Shopify selling plan, ID:', vm.sellingPlanId);
        } else {
          vm.hasSellingPlan = false;
          console.log('WARNING: Product does not have selling plans - subscription may not work properly');
        }
        
        console.log('vm.product:::', vm.product)
        for (let i = 0; i < vm.product.variants.length; i++){
          var variant_test = vm.product.variants[i].title
          console.log('Checking variant', i, ':', variant_test, 'vs compareIt:', compareIt);
          console.log('Variant ID:', vm.product.variants[i].id);
          if (variant_test == compareIt) {
            console.log('=== VARIANT MATCH FOUND ===');
            console.log('Matched variant:', vm.product.variants[i]);
            vm.variant = vm.product.variants[i];
            var handle = vm.productHandle;
            console.log('Product handle:', handle);
            var item = vm.product.variants[i].id;
            console.log('Variant ID from product:', item);
              // Always use the regular variant ID - selling plans handle subscription pricing
              vm.finalID = vm.product.variants[i].id;
              if (vm.gift) {
                console.log('Gift product - using prepaid variant ID:', vm.finalID);
              } else {
                console.log('Using regular variant ID:', item);
              }
              console.log('Final ID set to:', vm.finalID);

            //console.log('vm.variant: ', vm.variant)
            //console.log('use this ID', vm.product.variants[i].id)
            //console.log('use this price', vm.product.variants[i].price)
            //vm.finalID = vm.product.variants[i].id
            break;

          }
        }
      });


      /* for(var i = 0; i < this.collection.products.length; i++) { //loop through the collection
        var obj = this.collection.products[i];
        console.log('obj: ', obj)
        if (obj.handle == create_handle){ // if new created tag matches on from the products in the collection, set that product ID to be current.
          //somehow get the proper products JSON. build new JSON url and do a GETJSON? and set this.product to it?
          
        }
      } */
    },

    goToStep(step) {
      //VueScrollTo.scrollTo('#subscription-app', 500, { easing: VueScrollTo.easing['ease'] });
      this.$scrollTo('#subscription-app', 200, { easing: 'linear' })
      if(step>this.currentStep){
        this.direction='nextStep'
      }
      else{
        this.direction='previousStep'
      }
      //console.log('direction', this.direction)
      this.currentStep = step;
      console.log('this.currentStep', this.currentStep)
      if (this.currentStep == 7){
        this.compareTitle = this.size + ' / ' + this.beanGrind;
        console.log('Looking for variant in step 7:', this.compareTitle);
          //console.log('this product: ', this.product)
          for (let i = 0; i < this.product.variants.length; i++){
            var variant_test = this.product.variants[i].title;
            if (variant_test == this.compareTitle) {
              this.variant = this.product.variants[i];
              var handle = this.productHandle;
              //console.log('testing handle: ', handle);
              var item = this.product.variants[i].id;
              
              // Check for selling plans when moving to step 7
              if (this.product && this.product.selling_plan_groups && this.product.selling_plan_groups.length > 0) {
                this.hasSellingPlan = true;
                console.log('Step 7: Product has selling plan groups:', this.product.selling_plan_groups);
                var sellingPlans = this.product.selling_plan_groups[0].selling_plans;
                console.log('Step 7: Available selling plans:', sellingPlans);
                
                // Match selling plan based on frequency
                // Clean the frequency value first (remove non-numeric characters)
                let cleanFrequency = typeof this.frequency === 'string' ? parseInt(this.frequency.replace(/\D/g,'')) : this.frequency;
                // Convert frequency from days to a searchable value
                let frequencyWeeks = Math.round(cleanFrequency / 7);
                let frequencyMonths = Math.round(cleanFrequency / 30);
                
                console.log('Step 7: Looking for selling plan matching frequency:', cleanFrequency, 'days (', frequencyWeeks, 'weeks /', frequencyMonths, 'months)');
                
                // Try to find a matching plan based on the frequency
                let matchedPlan = sellingPlans.find(plan => {
                  const planNameLower = plan.name.toLowerCase();
                  
                  // Check for week-based matches
                  if (cleanFrequency == 7 && (planNameLower.includes('1 week') || planNameLower.includes('7 day'))) {
                    return true;
                  }
                  if (cleanFrequency == 14 && (planNameLower.includes('2 week') || planNameLower.includes('14 day'))) {
                    return true;
                  }
                  if (cleanFrequency == 21 && (planNameLower.includes('3 week') || planNameLower.includes('21 day'))) {
                    return true;
                  }
                  if (cleanFrequency == 28 && (planNameLower.includes('4 week') || planNameLower.includes('28 day'))) {
                    return true;
                  }
                  if (cleanFrequency == 30 && (planNameLower.includes('1 month') || planNameLower.includes('30 day'))) {
                    return true;
                  }
                  if (cleanFrequency == 60 && (planNameLower.includes('2 month') || planNameLower.includes('60 day'))) {
                    return true;
                  }
                  
                  // Generic number matching
                  if (planNameLower.includes(cleanFrequency.toString())) {
                    return true;
                  }
                  
                  return false;
                });
                
                if (matchedPlan) {
                  this.sellingPlanId = matchedPlan.id;
                  console.log('Step 7: Matched selling plan:', matchedPlan.name, 'ID:', this.sellingPlanId);
                } else {
                  // Fallback to first plan if no match
                  this.sellingPlanId = sellingPlans[0].id;
                  console.log('Step 7: No frequency match, using first selling plan:', this.sellingPlanId);
                  console.log('Step 7: Available plan names:', sellingPlans.map(p => p.name));
                }
              } else {
                console.log('Step 7: No selling plans found in product');
                console.log('Step 7: Product data:', this.product);
                this.hasSellingPlan = false;
                this.sellingPlanId = null;
              }
              
              // Always use the variant ID - selling plans handle subscription pricing
              this.finalID = this.product.variants[i].id
              
              //console.log('use this ID else', this.finalID)
              //console.log('use this price else', this.variant.price);
            }
          }
      }else {
        $('.sidebar').show();
      }
    },

    /* this could be used in a true/false condition to display or not display offered sizes
    checkVariantExists(sizeTitle) {
      
      var coffeeVariant = this.coffeeType + ' / ' + sizeTitle;
      var item = this.variantData.find( item => {
        return item.title === coffeeVariant
      });
      if (item === undefined) {
        return false
      } else {
        return true
      }
    }, */
    getVariantPrice(sizeTitle) {
      this.sizeTitle = sizeTitle;
      var coffeeVariant = this.coffeeType + ' / ' + sizeTitle;
      let item = this.variantData.find( item => {
          return item.title === coffeeVariant
      });
      if (item === undefined) {
        return ' '
      } else {
        return '$' + item.price
      }
    },
    appear: function(el) {
      console.log('appear!')
    },
    chooseGift(value) {
      this.gift = value;
    },
    selectCoffeeType(type, img) {
      this.coffeeType = type;
      this.coffeeTypeImg = img;
      this.setProductHandle(type);
      if (this.completedStep < 2) {
        this.completedStep = 2;
        //console.log('this.completedStep: ', this.completedStep)
      }
    },
    selectCoffeeTypeGift(type, img) {
      this.coffeeType = type;
      this.coffeeTypeImg = img;
      if (this.completedStep < 2) {
        this.completedStep = 2;
        //console.log('this.completedStep: ', this.completedStep)
      }
    },
    selectBeanGrind(bean, beanimg) {
      this.beanGrind = bean;
      this.beanGrindImg = beanimg;
      if (this.completedStep < 3) {
        this.completedStep = 3;
        //console.log('this.completedStep: ', this.completedStep)
      }
    },
    selectSize(sizeValue, sizeimg, shippingPrice) {
      this.size = sizeValue;
      this.sizeImg = sizeimg;
      this.shippingPrice = shippingPrice;

      if (sizeValue.toLowerCase().indexOf('one') !== -1) {
        this.sizeNum = 1;
      }
      if (sizeValue.toLowerCase().indexOf('two') !== -1) {
        this.sizeNum = 2;
      }
      if (sizeValue.toLowerCase().indexOf('four') !== -1) {
        this.sizeNum = 3;
      }

      if (this.completedStep < 4) {
        this.completedStep = 4;
        //console.log('this.completedStep: ', this.completedStep)
      }
    },
    frequencyTime(freq, freqimg) {
      this.frequency = freq;
      this.frequencyImg = freqimg;
      if (this.completedStep < 5) {
        this.completedStep = 5;
        //console.log('this.completedStep: ', this.completedStep)
      }
      
      // If we're on step 7, we need to re-select the variant since frequency changed
      if (this.currentStep == 7 && this.product && this.product.variants) {
        this.compareTitle = this.size + ' / ' + this.beanGrind;
        console.log('Re-selecting variant after frequency change:', this.compareTitle);
        for (let i = 0; i < this.product.variants.length; i++){
          var variant_test = this.product.variants[i].title;
          if (variant_test == this.compareTitle) {
            this.variant = this.product.variants[i];
            console.log('Variant re-selected:', this.variant);
            break;
          }
        }
        
        // Update selling plan selection based on new frequency
        if (this.product.selling_plan_groups && this.product.selling_plan_groups.length > 0) {
          let cleanFrequency = typeof freq === 'string' ? parseInt(freq.replace(/\D/g,'')) : freq;
          console.log('Updating selling plan for new frequency:', cleanFrequency);
          // The selling plan selection logic will run in the template/computed properties
        }
      }
    },
    frequencyTimeGift(freq, freqimg, freq_gift_title) {
      this.frequency = freq;
      this.frequencyImg = freqimg;
      this.freq_gift_title = freq_gift_title;

      if (freq.indexOf('7') !== -1) {
        this.frequencyNum = 7;
      }
      if (freq.indexOf('14') !== -1) {
        this.frequencyNum = 14;
      }
      if (freq.indexOf('30') !== -1) {
        this.frequencyNum = 30;
      }

      if (this.completedStep < 5) {
        this.completedStep = 5;
        //console.log('this.completedStep: ', this.completedStep)
      }
      
      // If we're on step 7, we need to re-select the variant since frequency changed (for gift flow)
      if (this.currentStep == 7 && this.product && this.product.variants) {
        this.compareTitle = this.size + ' / ' + this.beanGrind;
        console.log('Re-selecting variant after gift frequency change:', this.compareTitle);
        for (let i = 0; i < this.product.variants.length; i++){
          var variant_test = this.product.variants[i].title;
          if (variant_test == this.compareTitle) {
            this.variant = this.product.variants[i];
            console.log('Gift variant re-selected:', this.variant);
            break;
          }
        }
      }
    },
    durationTime(dur, durimg) {
      this.duration = dur;
      this.summary = true;
      this.durationImg = durimg;
      
      if (dur.toLowerCase().indexOf('3') !== -1) {
        this.durationNum = 90;
      }
      if (dur.toLowerCase().indexOf('4') !== -1) {
        this.durationNum = 120;
      }
      if (dur.toLowerCase().indexOf('6') !== -1) {
        this.durationNum = 180;
      }
      if (dur.toLowerCase().indexOf('12') !== -1) {
        this.durationNum = 360;
      }

      if (this.completedStep < 6) {
        this.completedStep = 6;
        //console.log('this.completedStep: ', this.completedStep)
      }
      
      // For gift subscriptions, fetch the product when duration is selected
      if (this.gift && this.freq_gift_title && this.coffeeType) {
        console.log('Duration selected for gift, fetching product...');
        this.getProduct();
      }
    },
    openPicker() {
      this.$refs.programaticOpen.showCalendar();
      const theInput = document.querySelector('#datedate');
      theInput.click();
    },
    customFormatter(date) {
      this.dateFormat = moment(date).format('MMMM Do YYYY');
      this.date = date;
    },
    getVariantData() {
      var create_URL = "https://joshua-tree-coffee-company.myshopify.com/products/"+ this.productHandle + ".js";
      fetch(create_URL).then(response => {
        // The API call was successful!
        if (response.ok) {
            return response.json();
        } else {
            return Promise.reject(response);
        }
    }).then( data => {
        console.log('here is the data: ', data);
        this.product = data;
        this.variantData = data.variants;

    }).catch(function (err) {
        //fetchFail(err)
        console.log(err);
    });

    },// this.productHandle is reset for gifts in getProduct()
    setProductHandle(productHandle) {
      var productHandleCleaned = productHandle.replace(/\s/g, '-');
      productHandleCleaned = productHandleCleaned.toLowerCase();
      // Add -coffee-subscription suffix to match the subscription products
      productHandleCleaned = productHandleCleaned + '-coffee-subscription';
      console.log('productHandleCleaned ', productHandleCleaned);
      this.productHandle = productHandleCleaned;
      this.getVariantData();
    },
    setVariantSubscriptionMap(handle, data) {
      var tmp = "{" + data + "}";
      var tmp2 =JSON.parse(tmp);
      //console.log('handle: ', handle, ' type of data now: ', typeof tmp2, tmp2)
      this.VariantSubscriptionMap[handle] = tmp2;
    },
    setCoffeeOptions(name, data) {
      var tmp1a = "{" + data + "}";
      //console.log('type of data first: ', typeof tmp, tmp);
      var tmp1b =JSON.parse(tmp1a);
      console.log('type of data now: ', typeof tmp1b, tmp1b)
      this.coffeeOptionsProductHandle = name;
      this.coffeeOptions[name] = tmp1b;
      console.log('this.coffeeOptions: ', typeof this.coffeeOptions, this.coffeeOptions)
    },
    setCoffeeParent(parent) {
      this.coffeeParent = parent;
      console.log('this.coffeeParent: ', this.coffeeParent)
    },
    checkGrind(current) {
      //console.log('current', current)
      //console.log('this.coffeeOptions[this.coffeeParent]: ', this.coffeeOptions[this.coffeeParent].grinds)
      if (!this.coffeeOptions[this.coffeeParent]) {
        return false;
      }
      let grinds = this.coffeeOptions[this.coffeeParent].grinds;
      //console.log('grinds: ', typeof grinds, grinds)
      let theGrind = grinds.find(val => val === current);
      //console.log('theGrind: ', theGrind)
      return theGrind ? true : false;
    },
    checkSize(current) {
      //console.log('current', current)
      //console.log('this.coffeeOptions[this.coffeeParent]: ', this.coffeeOptions[this.coffeeParent].grinds)
      let sizes = this.coffeeOptions[this.coffeeParent].sizes;
      //console.log('grinds: ', typeof grinds, grinds)
      let theSize = sizes.find(val => val === current);
      //console.log('theGrind: ', theGrind)
      return theSize ? true : false;
    },

    setVariantGiftWrap(id) {
      this.giftWrapVariantId = id;
    },
    setVariantCartNote(id) {
      this.cartNoteVariantId = id;
    },

    getInput(name, email){
      this.giftName = name;
      this.giftEmail = email;
    },

    isActive(step) {
      console.log('step: ', step, ' completedStep: ', this.completedStep, ' gift: ', this.gift)
      if (step === this.currentStep || step === this.completedStep + 1) return 'active';
      if (step === 7 && this.completedStep === 5 && this.gift === false) return 'active';
      if (step === 7 && this.completedStep === 6 && this.gift === true) return 'active';
      return 'notActive'
    },

    addItemToCart(variant_id, qty, frequency, unit_type) {
      console.log('=== SUBSCRIPTION CHECKOUT STARTED ===');
      console.log('Parameters received:', {variant_id}, {qty}, {frequency}, {unit_type});
      console.log('finalID being used:', this.finalID);
      console.log('=== VARIANT DEBUGGING ===');
      console.log('Available product variants:', this.product && this.product.variants ? this.product.variants : 'No product data');
      console.log('Selected coffee type:', this.coffeeType);
      console.log('Selected size:', this.size);
      console.log('Selected grind:', this.beanGrind);
      console.log('Current variant object:', this.variant);
      console.log('Product handle:', this.productHandle);
      
      // Check if finalID looks like a product ID vs variant ID
      if (this.finalID) {
        console.log('finalID type analysis:');
        console.log('- Length:', this.finalID.toString().length);
        console.log('- Starts with 4299:', this.finalID.toString().startsWith('4299'));
        console.log('- This might be a', this.finalID.toString().length > 11 ? 'product ID' : 'variant ID');
        
        // Fix: Find correct variant ID if we have a product ID
        if (this.finalID.toString().length > 11 && this.product && this.product.product) {
          console.log('=== FIXING VARIANT ID ===');
          var compareIt = this.size + ' / ' + this.beanGrind;
          console.log('Looking for variant matching:', compareIt);
          
          for (let i = 0; i < this.product.variants.length; i++) {
            var variant = this.product.variants[i];
            console.log('Checking:', variant.title);
            if (variant.title === compareIt) {
              console.log('FOUND MATCH! Using variant ID:', variant.id);
              this.finalID = variant.id;
              this.variant = variant;
              break;
            }
          }
        }
      }

      if ( this.date === '' ) {
        let today =   new Date();
        this.date = today;
        this.dateFormat = moment(today).format('MMMM Do YYYY');//
      }
      console.log('this.date', this.date);

      function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
      this.frequency = this.frequency.replace(/\D/g,'');
      console.log('addtocart frequency: ', this.frequency)
      
      // Set default values if missing BEFORE creating data object
      if (!this.quantity || this.quantity === '') {
        this.quantity = '1';
        console.log('Setting default quantity to 1');
      }
      
      if (!this.duration || this.duration === '') {
        this.duration = 'Ongoing';
        console.log('Setting default duration to Ongoing');
      }
      
      var data;
      
      if (this.gift) {
        // Gift products might have selling plans (new Shopify) or be ReCharge products (old)
        data = {
          "id": this.finalID,
          "quantity": 1,
          "properties": {
            "Choose_Coffee": this.coffeeType,
            "beanGrind": this.beanGrind,
            "Size": this.size,
            "Quantity": this.quantity,
            "Duration": this.duration,
            "Frequency": this.freq_gift_title,
            "gift_name": this.giftName,
            "gift_email": this.giftEmail,
            "gift_wrap": this.giftWrap,
            "scheduled_at": moment(this.date).format('YYYY-MM-DDTHH:mm:ss'),
            // Recharge-specific properties that are automatically honored
            "_rc_first_charge_date": moment(this.date).format('YYYY-MM-DD'),
            "delivery_date": moment(this.date).format('YYYY-MM-DD')
          }
        };
        
        // Check if the product has a selling plan (new Shopify subscriptions)
        if (this.hasSellingPlan && this.sellingPlanId) {
          data.selling_plan = this.sellingPlanId;
          console.log('Gift product has Shopify selling plan, adding ID:', this.sellingPlanId);
          console.log('Using variant ID:', this.finalID, 'with selling plan:', this.sellingPlanId);
        } else if (this.product && this.product.selling_plan_groups && this.product.selling_plan_groups.length > 0) {
          // Fallback check if hasSellingPlan wasn't set
          var sellingPlanId = this.product.selling_plan_groups[0].selling_plans[0].id;
          data.selling_plan = sellingPlanId;
          console.log('Gift product has Shopify selling plan (fallback), adding ID:', sellingPlanId);
          console.log('Using variant ID:', this.finalID, 'with selling plan:', sellingPlanId);
        } else {
          console.log('WARNING: Gift product is using old ReCharge system (no selling plan) - subscription may fail');
        }
        
        if (this.numShipments) {
          data.properties.expire_after_specific_number_of_charges = this.numShipments.toString();
          console.log('Gift subscription will expire after', this.numShipments, 'charges');
        }
      } else {
        // Regular subscription
        data = {
          "id": this.finalID,
          "quantity": 1,
          "properties": {
            "Choose_Coffee": this.coffeeType,
            "beanGrind": this.beanGrind,
            "Size": this.size,
            "Quantity": this.quantity,
            "Duration": this.duration,
            "gift_name": this.giftName,
            "gift_email": this.giftEmail,
            "gift_wrap": this.giftWrap,
            "subscription_id": this.subscription_id,
            "scheduled_at": moment(this.date).format('YYYY-MM-DDTHH:mm:ss'),
            // Recharge-specific properties that are automatically honored
            "_rc_first_charge_date": moment(this.date).format('YYYY-MM-DD'),
            "delivery_date": moment(this.date).format('YYYY-MM-DD'),
            "shipping_interval_frequency": this.frequency,
            "shipping_interval_unit_type": "day",
            "order_interval_unit":"day",
            "order_interval_frequency":this.frequency
          }
        };
        
        // Add selling plan if available
        if (this.hasSellingPlan && this.sellingPlanId) {
          data.selling_plan = this.sellingPlanId;
          console.log('Regular subscription has Shopify selling plan, adding ID:', this.sellingPlanId);
          console.log('Using variant ID:', this.finalID, 'with selling plan:', this.sellingPlanId);
          console.log('Data object with selling plan:', data);
        } else if (this.product && this.product.selling_plan_groups && this.product.selling_plan_groups.length > 0) {
          // Fallback: try to get selling plan if hasSellingPlan wasn't set
          const sellingPlans = this.product.selling_plan_groups[0].selling_plans;
          if (sellingPlans && sellingPlans.length > 0) {
            data.selling_plan = sellingPlans[0].id;
            console.log('Regular subscription using fallback selling plan, ID:', sellingPlans[0].id);
          } else {
            console.log('WARNING: No selling plans found in product');
          }
        } else {
          console.log('WARNING: Regular subscription product missing selling plan - subscription may fail');
          console.log('Product data:', this.product);
        }
      }
      console.log('=== CART DATA PREPARED ===');
      console.log('Cart data:', data);
      console.log('Gift wrap selected:', this.giftWrap);
      console.log('Cart note:', this.cartNote);
      console.log('Cart note selected:', this.cartNoteSelected);
      console.log('=== FINAL VALUES BEING SENT ===');
      console.log('Duration:', this.duration);
      console.log('Quantity:', this.quantity);
      console.log('Size:', this.size);
      console.log('Frequency:', this.frequency);
      if (this.cartNote !== '') {
        console.log('noted: ', this.cartNote);
      }
      // this.whatEver is not available in the jQuery function below, so we set the values here:
      // because 'this' has a different context in that function
      // var isGift = this.giftWrap;
      var theCartNote = this.cartNote;
      var theCartNoteSelected = this.cartNoteSelected;
      var that = this.$store;


    //if we have a cart note variant ID, a cart note, the cart note checkbox selected and a gift wrap variant ID
      if ( this.cartNoteVariantId && this.cartNote && this.cartNoteSelected && this.giftWrap ) {
        data = { items: [
            data,
            {
              id: this.giftWrapVariantId,
              quantity: 1
            },
            {
              id: this.cartNoteVariantId,
              quantity: 1
            }
          ]
        } 
        console.log('updated data 1: ', data);

        // else we may have a cart note variant ID, a cart note
      } else if ( this.cartNoteVariantId && this.cartNote && this.cartNoteSelected ) {
          data = { items: [
            data,
            {
              id: this.cartNoteVariantId,
              quantity: 1
            }
          ]
        } 
        console.log('updated data 2: ', data);

        // and we may only have a gift wrap variant ID
      } else if ( this.giftWrap ) {
        /* newData = {
          items
        } */
        data = { items: [
            data,
            {
              id: this.giftWrapVariantId,
              quantity: 1
            }
          ]
        }
        console.log('updated data 3: ', data);
      }
      console.log('updated data: ', data)

      

      function updateTheCart() {
        that.dispatch('cart/init');
      }

      console.log('=== SENDING CART ADD REQUEST ===');
      console.log('URL: /cart/add.js');
      console.log('Data being sent:', JSON.stringify(data, null, 2));
      
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function () {
          console.log('=== CART ADD SUCCESS ===');
          updateTheCart();
          if (theCartNote && theCartNoteSelected) {
            //console.log('we have a note.')
            jQuery.post('/cart/update.js', {updates: {note: theCartNote}});
          }
          /* if (isGift) {
            //console.log('gift wrap!');
            jQuery.post('/cart/update.js', "attributes[Gift wrap]=Yes");
          } */

          //console.log(data.properties);
          do {
            var token=get_cookie('cart');
          }
          while(token == undefined);

          var myshopify_domain='{{ shop.permanent_domain }}'
          try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
          var customer_param = '{% if customer %}customer_id={{customer.id}}&customer_email={{customer.email}}{% endif %}'
          var checkout_url = "/checkout?myshopify_domain=joshua-tree-coffee-company.myshopify.com&cart_token=" + token + "&" + ga_linker;
          console.log('=== REDIRECTING TO CHECKOUT ===');
          console.log('Generated checkout URL:', checkout_url);
          console.log('Cart token:', token);
          console.log('GA linker:', ga_linker);
          setTimeout(function() {
            console.log('Redirecting now...');
            window.location = checkout_url
          }, 500)
          
        },
        error: function(xhr, status, error) {
          console.log('=== CART ADD FAILED ===');
          console.log('Status:', status);
          console.log('Error:', error);
          console.log('Response:', xhr.responseText);
          console.log('Status Code:', xhr.status);
          
          if (xhr.status === 422 && xhr.responseText.includes('Cannot find variant')) {
            console.log('=== VARIANT NOT FOUND ERROR ===');
            console.log('The variant ID', data.id, 'does not exist in this store');
            console.log('This usually means there is a mismatch between the selected options and available variants');
            console.log('Check the product setup or variant matching logic');
          }
        }
      });
    },
    setAppBg (imgPath, pad_top, pad_bottom) {
      let app_bg = document.querySelector('#subscription-app-wrap');
      if (app_bg) {
        //console.log('app_bg: ', app_bg)
        app_bg.style.backgroundImage = "url(" + imgPath + ")";
        app_bg.style.paddingTop = pad_top;
        app_bg.style.paddingBottom = pad_bottom;

      }
      return '';

    }

  }
}).$mount('#app');

console.log('✅ Vue mounted successfully to #app');

} catch (error) {
  console.error('❌ Failed to initialize Vue:', error);
  console.error('Vue initialization stack trace:', error.stack);
  
  // Try to show a basic error message to the user
  var appElement = document.getElementById('app');
  if (appElement) {
    appElement.innerHTML = '<div style="padding: 20px; color: red; border: 1px solid red;">Vue application failed to load. Check browser console for details.</div>';
    appElement.style.display = 'block';
  }
}

let iconLinks = document.querySelectorAll('.service-icon-link');

const showHover = function(e) {
  let serviceIcon = e.target;
  let serviceIconSrc = serviceIcon.dataset.rollover_img;
  serviceIcon.querySelector('.service-icon-img').src = serviceIconSrc;
}
const showNormal = function(e) {
  let serviceIcon = e.target;
  let serviceIconSrc = serviceIcon.dataset.original_img;
  serviceIcon.querySelector('.service-icon-img').src = serviceIconSrc;
}

if ( iconLinks.length > 0 ) {
  iconLinks.forEach(function(el) {
    el.addEventListener('mouseenter', showHover);
    el.addEventListener('mouseleave', showNormal);
  })
}